import InventoryManagement from "../../components/InventoryManagement/InventoryManagement";

const InventoryManagementPage = () => {
  return <InventoryManagement />;
};

export default InventoryManagementPage;
